<template>
  <div class="main-project-list">
    <el-row>
      <el-form
        :inline="true"
        :model="searchForm"
        class="demo-form-inline search-form"
        size="small"
      >
        <el-form-item>
          <el-input
            v-model="searchForm.cerName"
            placeholder="级别名称"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-input
            v-model="searchForm.cerCode"
            placeholder="级别编号"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="创建时间:">
          <el-date-picker
            v-model="registerDate"
            clearable
            type="daterange"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="onSearchCer"
            icon="el-icon-search"
            :loading="cerPager.loading"
            >查询</el-button
          >
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="cerFormVisible = true"
            icon="el-icon-plus"
            >新增</el-button
          >
        </el-form-item>
      </el-form>
    </el-row>
    <el-card shadow="never" class="card-fix-height scrollable">
      <el-table
        :data="cerPager.tableData"
        v-loading="cerPager.loading"
        row-key="id"
        stripe
        style="width: 100%"
      >
        <el-table-column
          prop="metaName"
          label="证书级别名称"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="metaCode"
          label="证书级别编号"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="createDate"
          label="创建时间"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column fixed="right" label="操作" align="center">
          <template slot-scope="scope">
            <el-button
              @click="updateCer(scope.row)"
              size="small"
              type="text"
              v-if="
                scope.row.metaName != '初级' &&
                  scope.row.metaName != '中级' &&
                  scope.row.metaName != '高级'
              "
              >编辑</el-button
            >
            <el-button
              @click="delCer(scope.row)"
              type="text"
              size="small"
              v-if="
                scope.row.metaName !== '初级' &&
                  scope.row.metaName !== '中级' &&
                  scope.row.metaName !== '高级'
              "
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-dialog
        title="添加证书级别"
        :visible.sync="cerFormVisible"
        width="600px"
      >
        <el-form
          :model="cerForm"
          ref="cerForm"
          :rules="cerRules"
          label-width="100px"
        >
          <el-form-item
            label="证书级别名称："
            label-width="150px"
            prop="cerName"
          >
            <el-input
              v-model="cerForm.cerName"
              placeholder="证书级别名称"
            ></el-input>
          </el-form-item>
        </el-form>
        <div align="center" class="dialog-footer">
          <el-button @click="cancel">取 消</el-button>
          <el-button type="primary" @click="addOrUpdateCer">确 定</el-button>
        </div>
      </el-dialog>
    </el-card>
    <el-pagination
      class="footer"
      background
      :layout="tableLayout"
      :total="cerPager.tableTotal"
      :current-page="cerPager.currentPage"
      :page-size.sync="pageSize"
      @current-change="onCerPageChange"
      align="center"
    >
    </el-pagination>
  </div>
</template>

<script>
import { searchCerPager, deleteCer, editCer } from "@/api/certificate";
import permission from "@/directive/permission"; // 权限判断指令
import { defaultPageConfig } from "@/config/pagination";
import { formatDate } from "@/utils";

export default {
  name: "CertificateLevel",
  directives: { permission },
  data() {
    return {
      searchForm: {
        cerName: null,
        cerCode: null,
        startDate: null,
        endDate: null
      },
      statusOptions: [
        { label: "未授权", value: 1 },
        { label: "已发布", value: 2 },
        { label: "已暂停", value: 3 }
      ],
      cerPager: {
        id: null,
        tableData: [],
        currentPage: 1,
        tableTotal: -1,
        tablePages: 0,
        loading: false
      },
      tableLayout: defaultPageConfig.layout,
      pageSize: defaultPageConfig.pageSize,
      registerDate: [],
      cerFormVisible: false,
      cerForm: {
        id: null,
        cerName: null
      },
      cerRules: {
        cerName: [
          { required: true, message: "请输入证书级别名称", trigger: "blur" }
        ]
      }
    };
  },
  watch: {
    registerDate(val) {
      if (val && val.length > 0) {
        this.searchForm.startDate = val[0] + " 00:00:00";
        this.searchForm.endDate = val[1] + " 23:59:59";
      } else {
        this.searchForm.startDate = null;
        this.searchForm.endDate = null;
      }
    }
  },
  created() {
    this.getCerPager();
  },
  methods: {
    // 条件查询
    onSearchCer() {
      this.cerPager.currentPage = 1;
      this.searchCerPager();
    },
    getCerPager() {
      let that = this;
      that.cerPager.loading = true;
      searchCerPager(this.searchForm, {
        page: this.cerPager.currentPage,
        pageSize: this.pageSize
      })
        .then(res => {
          if (res && res.code === "200") {
            that.cerPager.tableTotal = Number(res.data.total);
            that.cerPager.tablePages = Number(res.data.pages);
            that.cerPager.tableData = res.data.list.map(item => {
              if (item.createDate) {
                item.createDate = formatDate(
                  item.createDate,
                  "yyyy-MM-dd HH:mm:ss"
                );
              }
              return item;
            });
          } else {
            that.cerPager.tableTotal = 0;
            that.cerPager.tablePages = 0;
            that.cerPager.tableData = [];
          }
        })
        .finally(() => {
          that.cerPager.loading = false;
        });
    },
    searchCerPager() {
      let that = this;
      that.cerPager.loading = true;
      searchCerPager(this.searchForm, {
        page: this.cerPager.currentPage,
        pageSize: this.pageSize
      })
        .then(res => {
          if (res && res.code === "200") {
            that.cerPager.tableTotal = Number(res.data.total);
            that.cerPager.tablePages = Number(res.data.pages);
            that.cerPager.tableData = res.data.list.map(item => {
              if (item.createDate) {
                item.createDate = formatDate(
                  item.createDate,
                  "yyyy-MM-dd HH:mm:ss"
                );
              }
              return item;
            });
          } else {
            that.cerPager.tableTotal = 0;
            that.cerPager.tablePages = 0;
            that.cerPager.tableData = [];
          }
        })
        .finally(() => {
          that.cerPager.loading = false;
        });
    },
    // 时间格式化
    formatTime(timestamp) {
      let date = new Date(timestamp);
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let day = date.getDate();
      let hour = date.getHours();
      let minute = date.getMinutes();
      let second = date.getSeconds();
      return (
        [year, month, day].map(this.formatNumber).join("-") +
        " " +
        [hour, minute, second].map(this.formatNumber).join(":")
      );
    },
    formatNumber(n) {
      n = n.toString();
      return n[1] ? n : "0" + n;
    },
    // 项目翻页
    onCerPageChange(page) {
      this.cerPager.currentPage = page;
      this.getCerPager();
    },
    // 删除项目
    delCer(row) {
      this.$confirm("项目删除后将无法恢复，确认删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(
        () => {
          deleteCer(row)
            .then(res => {
              if (res.code === "200") {
                this.$message({
                  message: "删除成功",
                  type: "success"
                });
              }
            })
            .finally(() => {
              this.getCerPager();
            });
        },
        () => {}
      );
    },
    // 跳转
    jumpPage(router) {
      this.$router.push(router);
    },
    addOrUpdateCer() {
      this.$refs["cerForm"].validate(valid => {
        if (valid) {
          this.editCer();
        } else {
          return false;
        }
      });
    },
    editCer: function() {
      editCer(this.cerForm).then(res => {
        if (res) {
          if (res.code === "200") {
            this.$message({
              message: "保存成功",
              type: "success"
            });
            this.cerForm.cerName = null;
            this.cerForm.id = null;
            this.cerFormVisible = false;
            this.getCerPager();
          }
        }
      });
    },
    updateCer(row) {
      this.cerForm.id = row.id;
      this.cerForm.cerName = row.metaName;
      this.cerFormVisible = true;
    },
    cancel() {
      this.cerFormVisible = false;
      this.cerForm.id = null;
      this.cerForm.cerName = null;
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.main-project-list {
  .dashboard {
    &-container {
      margin: 30px;
    }
    &-text {
      font-size: 30px;
      line-height: 46px;
    }
  }
  .admin-k100 {
    width: 100%;
  }
  .card-fix-height {
    position: relative;
    height: calc(100vh - 84px - 15px - 40px - 51px - 52px - 2px - 30px);
  }
  .button {
    padding-bottom: 20px;
  }
}
</style>
